import * as L from 'leaflet';
import last from 'lodash/last';
import first from 'lodash/first';
import { Marker } from 'react-leaflet';
import { LabelType } from '../../models/label-type.enum';
import { DateHelper } from '../../../../../../../../../helpers/date.helper';
import type { ICallDetails } from '../../../../../../../../../models/call-details.model';
import type { IServiceJourneyDetails } from '../../../../../../../../../models/service-journey-details.model';
import LabelHelper from '../../../helpers/label.helper';
import './style.scss';

function getTimeString(call: ICallDetails, labelType: LabelType): string {
  let time: string | undefined;
  if (labelType === LabelType.departure) {
    time = call.estimatedDepartureTime ? call.estimatedDepartureTime : call.plannedDepartureTime;
  } else {
    time = call.estimatedArrivalTime ? call.estimatedArrivalTime : call.plannedArrivalTime;
  }
  return DateHelper.getTimeFromDateTimeString(time);
}

function TripLegLabelMarker({ serviceJourney, labelType, disabled }: { serviceJourney: IServiceJourneyDetails; labelType: LabelType; disabled: boolean }) {
  const call = labelType === LabelType.departure ? first(serviceJourney.callsOnServiceJourney?.filter((c) => c.isOnTripLeg)) : last(serviceJourney.callsOnServiceJourney?.filter((c) => c.isOnTripLeg));
  const vericalAnchorPoint = labelType === LabelType.departure ? -3 : 29;

  if (!call || !call.latitude || !call.longitude) {
    return null;
  }

  const icon = L.divIcon({
    className: `trip-leg-label-marker w-auto h-auto ${disabled ? 'trip-leg-label-marker--disabled' : ''}`,
    html: LabelHelper.createIconHtml(serviceJourney.line.transportMode, getTimeString(call, labelType), serviceJourney.line, call.isCancelled),
    iconAnchor: [-10, vericalAnchorPoint],
  });

  return <Marker icon={icon} position={[call.latitude, call.longitude]} />;
}

export default TripLegLabelMarker;
